<div class="alert" style="margin-bottom: 0px;">
  <div class="modal-header ">
    <h4 class="modal-title pull-left">AI Data Extraction in Progress</h4>
  </div>
  <div class="modal-body"  >
    This dialog will close automatically when complete.
  </div>
  <div class="modal-footer justify-content-center">
   <button id="confirmation-dialog-ok-button"  type="button" class="btn btn-primary s_btn-confirmation-ok mr-2 mt-3"   (click)="closeModal(ConfirmationDialogButton.Ok)">
      Return to Matter List
   </button>
 
  </div>
</div>
<ng-template #matterSubtypeTemplate let-model="item">
  <span class="subtypePicklist">{{model.name}}</span>

</ng-template>